import { AppIds, LoginProviderType } from "@whatslly/types/LoginProviderType";

type ConfigResponse = {
  urlSuffix: string;
};

export const getConfigFromLoginProvider = (loginProvider: LoginProviderType, urlExtension: string): ConfigResponse => {
  if (loginProvider === AppIds.MICROSOFT_DYNAMICS) {
    return { urlSuffix: `/dynamics/${urlExtension}` };
  }
  if (loginProvider === AppIds.HUBSPOT) {
    return { urlSuffix: `/hubspot/${urlExtension}` };
  }
  if (loginProvider === AppIds.GOOGLE || loginProvider === AppIds.SAML || loginProvider === AppIds.MICROSOFT) {
    return { urlSuffix: `/auth/${urlExtension}` };
  }
  return { urlSuffix: `/sfdc/v2/${urlExtension}` };
};
